<template>
  <div class="dsf-alter-password-control" v-show="!loading">
    <div class="step-box" v-if="!step">
      <p class="title">{{title}}<span>{{notice}}</span></p>
      <div class="dsf-alter-password-label">旧密码</div>
      <!-- <input type="password" v-model="oldPwd" class="dsf-alter-password-input" placeholder="请输入旧密码" /> -->
      <el-input type="password" v-model="oldPwd" class="dsf-alter-password-input" placeholder="请输入旧密码" show-password></el-input>
      <br />
      <div class="dsf-alter-password-label">新密码</div>
      <!-- <input type="password" v-model="newPwd" class="dsf-alter-password-input" placeholder="请输入新密码" /> -->
      <el-input type="password" v-model="newPwd" class="dsf-alter-password-input" placeholder="请输入新密码" show-password></el-input>
      <br />
      <div class="dsf-alter-password-label">确认新密码</div>
      <!-- <input type="password" v-model="confirmPwd" class="dsf-alter-password-input" placeholder="请再次输入新密码" /> -->
      <el-input type="password" v-model="confirmPwd" class="dsf-alter-password-input" placeholder="请再次输入新密码" show-password></el-input>
      <p class="error-msg" v-if="alterResult">
        <i class="iconfont icon-tixingshixin" />
        {{alterResult}}
      </p>
      <br />
      <p style="color: red; font-size: 14px; height: 30px; line-height: 30px; margin-top: 15px">{{ tips }}</p>
      <el-button type="primary" class="dsf-alter-password-btn" :class="{ disabled: !(oldPwd && oldPwd != newPwd && newPwd && newPwd === confirmPwd) }" :disabled="!(oldPwd && oldPwd != newPwd && newPwd && newPwd === confirmPwd)" @click="nextStep">
        下一步
      </el-button>
    </div>
    <div class="step-box" v-if="step">
      <div class="step-succss">
        <i class="el-icon-check" />
      </div>
      <p class="success-tip">登录密码修改成功,{{setTimeout}}秒后自动退出</p>
      <el-button @click="backLogin" type="primary" class="dsf-alter-password-success-btn">
        重新登录
      </el-button>
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfPlatformAlterPassword",
  ctrlCaption: "修改密码",
  mixins: [$mixins.control],
  props: {
    title: {
      type: String,
      default: "修改密码"
    },
    alterUrl: {
      type: String,
      default: "oua2/user/pwd/selfupdate"
    },
    intervalUrl: {
      type: String,
      default: "oua2/user/pwd/send/interval"
    },
    errorTips: {
      type: String,
      default: "新密码不能与旧密码一样，请重新输入"
    },
    onSuccess:{
      default:null
    }
  },
  computed: {
    // tips() {
    //   if (this.oldPwd && this.newPwd && this.oldPwd === this.newPwd) {
    //     return this.errorTips;
    //   }
    //   return "";
    // }
  },
  data() {
    return {
      loading: false,
      notice: "密码设置6到20位,必须包含大写字母、小写字母、数字",
      // 是否修改成功
      step: false,
      // 旧密码
      oldPwd: "",
      // 新密码
      newPwd: "",
      // 确认 新密码
      confirmPwd: "",
      // 返回错误结果
      alterResult: "",
      tips: '',
      setTimeout:5,
    };
  },
  mounted() {
    this.loading = true;
    this.$http
      .get(this.intervalUrl, {})
      .done(({ success, data }) => {
        if (success) {
          this.notice = data.notice;
        }
      })
      .error((err) => {
        dsf.error(err);
      })
      .always(() => {
        this.loading = false;
      });
  },
  methods: {
    nextStep() {
      this.alterPwd();
    },
    setTimeoutExit(){
      if(this.setTimeout<=0){
        this.backLogin()
        return;
      }
      this.setTimeout--;
      clearTimeout(this.stopExit);
      this.stopExit = setTimeout(() => {
        this.setTimeoutExit()
      },1000)
    },
    alterPwd() {
      this.$http
        .post(this.alterUrl, {
          oldParam: dsf.sm2.encode(this.oldPwd, dsf.config.setting_public_smpublickey),
          param: dsf.sm2.encode(this.newPwd, dsf.config.setting_public_smpublickey)
        })
        .done(({ success, message }) => {
          if (success) {
            this.loginOut()
          } else {
            this.alterResult = message;
          }
        })
        .error((err) => {
          dsf.error(err);
          dsf.layer.message(err?.message || "请求异常", false);
        })
        .always(() => {});
    },
    loginOut(){
      this.$webAPI
        .loginOut()
        .then(({ success, message }) => {
          if (success) {
            dsf.storage.session.clear();
            this.step = true;
            this.onSuccess?.()
            this.setTimeoutExit()
          } else {
            dsf.layer.message(message, false);
          }
        })
        .catch((err) => {
          console.error(err);
          dsf.layer.message("退出失败", false);
        });
    },
    backLogin(){
      if (this.$listeners["complete"]) {
        this.$dispatch("complete");
      } else {
        location.replace(dsf.config.setting_public_pc_login_page);
      }
    },
    checkPwd:_.debounce(function () {
      if (this.oldPwd && (this.newPwd || this.confirmPwd)) {
        if (this.oldPwd === this.newPwd || this.oldPwd === this.confirmPwd) {
          this.tips = this.errorTips
        } else if(this.newPwd && this.confirmPwd) {
          if (this.newPwd != this.confirmPwd) {
            this.tips = "两次新密码输入不一致，请重新输入"
          } else {
            this.tips = ''
          }
        } else {
          this.tips = ''
        }
      }
      
    }, 300)
  },
  beforeDestroy() {
    clearTimeout(this.stopExit);
  },
  watch: {
    oldPwd() {
      this.checkPwd()
    },
    newPwd() {
      this.checkPwd()
    },
    confirmPwd() {
      this.checkPwd()
    }
  },
});
</script>
